import React from 'react';

export function SegmentedControl({ options, value, onChange, ariaLabel }) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-8)' }}
    >
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(opt.value)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              height: 'var(--space-40)',
              padding: '0 var(--space-16)',
              borderRadius: 'var(--radius-full)',
              border: `var(--stroke-small) solid ${
                active
                  ? 'var(--border-brand-default)'
                  : 'var(--border-neutral-strong)'
              }`,
              background: active
                ? 'var(--bg-brand-subtler)'
                : 'var(--bg-neutral-layer01)',
              color: active
                ? 'var(--fg-brand-stronger)'
                : 'var(--fg-neutral-subtle)',
              fontFamily: 'inherit',
              fontSize: 'var(--fs-14)',
              fontWeight: 'var(--fw-medium)',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              transition: 'background-color 120ms ease, border-color 120ms ease',
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
